import Vue from 'vue';
import { VueSignalR } from '@/signalr/plugin';
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';
import auth from '@/plugins/auth-service';

const signalrHubUrl = process.env.VUE_APP_API_SERVER_PATH + 'supervisor/hub';

const connection = new HubConnectionBuilder()
  .withUrl(signalrHubUrl, {
    withCredentials: true,
    accessTokenFactory: async () => {
      return await auth.getAccessToken();
    },
    skipNegotiation: true,
    transport: HttpTransportType.WebSockets,
  })
  .build();

Vue.use(VueSignalR, {
  connection,
  autoOffInsideComponentScope: true,
  failFn: (error) => {
    if (error) {
      console.log('SignalR connection failed');
    }
  },
});
